import * as React from "react"
import type { SVGProps } from "react"
const SvgOpenEmailEmpty = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m13.03 2.31 8.02 4.8q.45.28.7.75.25.48.25 1v10.85q0 .82-.59 1.42a2 2 0 0 1-1.41.58H4q-.82 0-1.41-.58A2 2 0 0 1 2 19.7V8.86q0-.52.25-1 .25-.47.7-.75l8.03-4.8A2 2 0 0 1 12 2.04q.55 0 1.02.28M12 13.36l7.8-4.65L12 4.06 4.2 8.71zm-1.02 1.73L4 10.9v8.8h16v-8.8l-6.97 4.18a2 2 0 0 1-1.03.27 2 2 0 0 1-1.02-.27" />
  </svg>
)
export default SvgOpenEmailEmpty
